export const SET_ACTIVE_TYPE = "adminCategory/SET_ACTIVE_TYPE";

export const RECEIVE_CATEGORIES = "adminCategory/RECEIVE_CATEGORIES";

export const SET_CATEGORY_EDITING = "adminCategory/SET_CATEGORY_EDITING";
export const EDIT_CATEGORY_PROP = "adminCategory/EDIT_CATEGORY_PROP";
export const EDIT_CATEGORY_BY_ID_PROP = "adminCategory/EDIT_CATEGORY_BY_ID_PROP";
export const UPDATE_CATEGORY = "adminCategory/UPDATE_CATEGORY";
export const DELETE_CATEGORY = "adminCategory/DELETE_CATEGORY";
export const REORDER_CATEGORIES = "adminCategory/REORDER_CATEGORIES";